import script from "./ConstructorParticipant.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructorParticipant.vue?vue&type=script&setup=true&lang=js"

import "./ConstructorParticipant.vue?vue&type=style&index=0&id=34960959&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34960959"]])

export default __exports__